import { render, staticRenderFns } from "./ScientificEffect.vue?vue&type=template&id=78461592&scoped=true"
import script from "./ScientificEffect.vue?vue&type=script&lang=js"
export * from "./ScientificEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78461592",
  null
  
)

export default component.exports